import { createFileRoute } from '@tanstack/react-router';
import { GiftCardsRouteError } from '@/features/gift-cards/error/gift-cards-route-error';
import { GiftCardsPage } from '@/features/gift-cards/gift-cards-page';

// Behind `_auth`: the details endpoint is session-scoped, so an anonymous
// visitor would only ever get an error state. The guard opens the login funnel
// instead (see `_auth.tsx`), and `ssr: false` matches it — the page is
// client-only and the guard resolves auth client-side.
export const Route = createFileRoute('/_auth/ixi-finance/gift-cards')({
	component: GiftCardsPage,
	errorComponent: GiftCardsRouteError,
	ssr: false,
});
